import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import PasswordInput from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.user);
      toast.success("Bienvenido de nuevo");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div
        className="hidden lg:flex w-1/2 bg-cover bg-center relative"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1606655762823-63f1cda5431f')" }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-borgona-900/90 via-borgona-900/40 to-transparent" />
        <div className="relative mt-auto p-14 text-blanco">
          <h1 className="font-serif text-5xl leading-tight mb-4">El arte de la<br />cata, elegante.</h1>
          <p className="text-blanco/80 max-w-md">Registra, evalúa y descubre cada vino con una ficha profesional de cata.</p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-6 py-12 bg-blanco-off">
        <div className="w-full max-w-md animate-fade-up">
          <img src="/vinote-logo.png" alt="Vinonotas" className="w-32 h-32 object-contain rounded-2xl mb-6" />
          <p className="text-xs uppercase tracking-[0.2em] text-dorado-700 mb-2">Bienvenido</p>
          <h2 className="font-serif text-3xl text-negro mb-8">Inicia sesión</h2>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label className="text-grises-600">Correo electrónico</Label>
              <Input
                data-testid="login-email-input"
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="catador@vinote.com" required className="mt-1.5 h-11"
              />
            </div>
            <div>
              <Label className="text-grises-600">Contraseña</Label>
              <PasswordInput
                testId="login-password-input"
                value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••" required className="mt-1.5 h-11"
              />
              <div className="text-right mt-1.5">
                <Link to="/recuperar" data-testid="forgot-password-link" className="text-sm text-borgona-700 hover:underline">¿Olvidaste tu contraseña?</Link>
              </div>
            </div>
            <Button
              data-testid="login-submit-btn"
              type="submit" disabled={loading}
              className="w-full h-11 bg-borgona-700 hover:bg-borgona-900 text-blanco rounded-full font-medium transition-colors duration-300"
            >
              {loading ? "Entrando..." : "Entrar"}
            </Button>
          </form>

          <p className="text-sm text-grises-500 mt-6">
            ¿No tienes cuenta?{" "}
            <Link to="/register" data-testid="go-register-link" className="text-borgona-700 font-medium hover:underline">Regístrate</Link>
          </p>
          <p className="text-xs text-grises-400 mt-4">Demo: catador@vinote.com / vinote123</p>
        </div>
      </div>
    </div>
  );
}
